import { generatePath } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";
import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { NewRoomEditContainer } from "@/components/features/items/edit/room/standard/default/ui/new";

import { useGetNewRoomEditPageParams } from "./_hooks/use-get-new-room-edit-page-params";

export const NewRoomDefaultEditPage = () => {
	const { hotelID, duplicateItemID } = useGetNewRoomEditPageParams();
	const activeLangCode = LangCode.Default;

	return (
		<PageMeta title="新規部屋の作成" url={generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.NEW.ROOM.DEFAULT, { hotelID })}>
			<NewRoomEditContainer hotelID={hotelID} roomID={duplicateItemID} activeLangCode={activeLangCode} />
		</PageMeta>
	);
};

NewRoomDefaultEditPage.displayName = "NewRoomDefaultEditPage";
